// extracted by mini-css-extract-plugin
export default {"display":"display___YrTYf","textRow":"textRow___h9fnJ","text":"text___rOD16","fallback":"fallback___jrkAv","key":"key___UIq7N"};